export default __webpack_public_path__ + "static/screenshot-actions--mobile-d523d4756f6611d26a8a64465afbbb57.png";